import styled from 'styled-components';
import { NumberRatingMixin } from '../../mixins/components/NumberRatingMixin';
export var StyledNumberRating = /*#__PURE__*/styled.span.withConfig({
  displayName: "StyledNumberRating",
  componentId: "c11n-8-111-1__sc-ilk12m-0"
})(["", ""], NumberRatingMixin);